import {
  CHANGE_LANG,
  CHANGE_CUSTOMER,
  GET_CUSTOMERS_FAILURE,
  GET_CUSTOMERS_PROCESSING,
  GET_CUSTOMERS_SUCCESS,
  OPEN_MODAL,
  CLOSE_MODAL,
  ADD_NOTIFICATION,
  REMOVE_NOTIFICATION,
  SET_CONTACTS_COUNT
} from '../config/constants';
import Message from '../locale/Message';
import { get } from './http_client';
import conf from '../config';

export const changeLangAction = lang => {
  console.log(
    lang
  );
  return ({
    type: CHANGE_LANG, lang
  });
}

export const logout = () => {
  document.location = `${conf.accountsUrl}/auth/realms/B2B/protocol/openid-connect/logout?redirect_uri=${encodeURI(
    document.location,
  )}`;
};

export const addNotificationAction = (message, isError = false) => dispatch => dispatch({
  type: ADD_NOTIFICATION,
  message,
  error: isError,
});

export const removeNotificationAction = id => dispatch => dispatch({
  type: REMOVE_NOTIFICATION,
  id,
});

export const redirectToProfile = () => {
  document.location = `${conf.accountsUrl}/settings`;
};

export const changeCustomerAction = customer => (dispatch, getState) => {
  dispatch({
    type: CHANGE_CUSTOMER,
    customer,
  });
};

export const getUserInfoAction = () => (dispatch, getState) => {
  const { userInfo, token, lang } = getState();

  if (userInfo.status !== 'DONE') {
    dispatch({ type: GET_CUSTOMERS_PROCESSING });
    get({
      url: `${conf.accountsUrl}/api/user/info/v1`,
      token,
      success: data => dispatch({
        type: GET_CUSTOMERS_SUCCESS,
        data,
      }),
      failure: message => dispatch({
        type: GET_CUSTOMERS_FAILURE,
        message: message || Message.systemError[lang],
      }),
    });
  }
};

export const openModalAction = ({ name }) => dispatch => dispatch({
  type: OPEN_MODAL,
  name,
});

export const closeModalAction = () => dispatch => dispatch({
  type: CLOSE_MODAL,
});

export const setContactsCount = (contactsCount) => dispatch => dispatch({
  type: SET_CONTACTS_COUNT,
  contactsCount
});
